// background sounds
import audio_idle from '@src/assets/sounds/idle_theme.mp3';
import audio_gameplay from '@src/assets/sounds/main_theme.mp3';
import audio_amb from '@src/assets/sounds/amb.mp3';

// win sounds
import audio_amount_count_up from '@src/assets/sounds/count_up.mp3';

// basic sounds
import audio_play_button from '@src/assets/sounds/play_button.mp3';
import audio_basic_click from '@src/assets/sounds/click.mp3';
import audio_modal_open from '@src/assets/sounds/modal_open.mp3';
import audio_transition from '@src/assets/sounds/transition.mp3';
import audio_spin_ball_spin from '@src/assets/sounds/spin_ball_spin.mp3';
import audio_spin_ball_mults from '@src/assets/sounds/spin_ball_mults.mp3';
import audio_wof_double_win from '@src/assets/sounds/wof_double_win.mp3';
import audio_win_reaction from '@src/assets/sounds/win_reaction.mp3';
import audio_chip from '@src/assets/sounds/win_reaction.mp3';

// win
import audio_default_win from '@src/assets/sounds/default_win.mp3';
import audio_big_win from '@src/assets/sounds/big_win.mp3';
import audio_super_win from '@src/assets/sounds/super_win.mp3';
import audio_epic_win from '@src/assets/sounds/epic_win.mp3';
import audio_mega_win from '@src/assets/sounds/mega_win.mp3';

// top slot
import audio_bonus_reels_spin from '@src/assets/sounds/bonus_reels_spin.mp3';
import audio_bonus_reels_left_stop from '@src/assets/sounds/bonus_reels_left_stop.mp3';
import audio_bonus_reels_right_stop from '@src/assets/sounds/bonus_reels_right_stop.mp3';

// plinko
import audio_plinko_start_position from '@src/assets/sounds/plinko_start_position.mp3';
import audio_plinko_multipliers_appearance from '@src/assets/sounds/plinko_multipliers_appearance.mp3';
import audio_plinko_collide from '@src/assets/sounds/plinko_collide.mp3';
import audio_plinko_mult_win from '@src/assets/sounds/plinko_mult_win.mp3';
import audio_plinko_double from '@src/assets/sounds/plinko_double.mp3';
// wheel of fortune
import audio_wof_appears from '@src/assets/sounds/wof_appears.mp3';
import audio_wof_start from '@src/assets/sounds/wof_start.mp3';
import audio_wof_spin from '@src/assets/sounds/wof_spin.mp3';
import audio_wof_stop from '@src/assets/sounds/wof_stop.mp3';
import audio_wof_win from '@src/assets/sounds/wof_win.mp3';
// cash reel
import audio_cash_reels_spin from '@src/assets/sounds/cash_reels_spin.mp3';
import audio_cash_reels_stop from '@src/assets/sounds/cash_reels_stop.mp3';
import audio_cash_reels_mult_win from '@src/assets/sounds/cash_reels_mult_win.mp3';
import audio_cash_reels_choice from '@src/assets/sounds/cash_reels_choice.mp3';

// Video posters
import video_poster from '@src/assets/video/video_poster.mp4';

// 3D videos
import video_black_win_1 from '@src/assets/video/black_cheer_var1.mp4';
import video_black_win_2 from '@src/assets/video/black_cheer_var8.mp4';
import video_blue_win_1 from '@src/assets/video/bluee_cheer_var1.mp4';
import video_green_win_1 from '@src/assets/video/green_cheer_var1.mp4';
import video_light_blue_win_1 from '@src/assets/video/lblue_cheer_var1.mp4';
import video_orange_win_1 from '@src/assets/video/orang_cheer_var1.mp4';
import video_pink_win_1 from '@src/assets/video/pinkk_cheer_var1.mp4';
import video_purple_win_1 from '@src/assets/video/purpl_cheer_var1.mp4';
import video_yellow_win_1 from '@src/assets/video/yello_cheer_var1.mp4';

// REAL videos
import video_black_win_1_real from '@src/assets/video/black_cheer_var1_real.mp4';
import video_black_win_2_real from '@src/assets/video/black_cheer_var8_real.mp4';
import video_blue_win_1_real from '@src/assets/video/bluee_cheer_var1_real.mp4';
import video_green_win_1_real from '@src/assets/video/green_cheer_var1_real.mp4';
import video_light_blue_win_1_real from '@src/assets/video/lblue_cheer_var1_real.mp4';
import video_orange_win_1_real from '@src/assets/video/orang_cheer_var1_real.mp4';
import video_pink_win_1_real from '@src/assets/video/pinkk_cheer_var1_real.mp4';
import video_purple_win_1_real from '@src/assets/video/purpl_cheer_var1_real.mp4';
import video_yellow_win_1_real from '@src/assets/video/yello_cheer_var1_real.mp4';

// 3D FAIL
import video_black_fail_1 from '@src/assets/video/black_usual_var1.mp4';
import video_black_fail_2 from '@src/assets/video/black_usual_var8.mp4';
import video_blue_fail_1 from '@src/assets/video/bluee_usual_var1.mp4';
import video_green_fail_1 from '@src/assets/video/green_usual_var1.mp4';
import video_light_blue_fail_1 from '@src/assets/video/lblue_usual_var1.mp4';
import video_orange_fail_1 from '@src/assets/video/orang_usual_var1.mp4';
import video_pink_fail_1 from '@src/assets/video/pinkk_usual_var1.mp4';
import video_purple_fail_1 from '@src/assets/video/purpl_usual_var1.mp4';
import video_yellow_fail_1 from '@src/assets/video/yello_usual_var1.mp4';

// REAL FAIL
import video_black_fail_1_real from '@src/assets/video/black_usual_var1_real.mp4';
import video_black_fail_2_real from '@src/assets/video/black_usual_var8_real.mp4';
import video_blue_fail_1_real from '@src/assets/video/bluee_usual_var1_real.mp4';
import video_green_fail_1_real from '@src/assets/video/green_usual_var1_real.mp4';
import video_light_blue_fail_1_real from '@src/assets/video/lblue_usual_var1_real.mp4';
import video_orange_fail_1_real from '@src/assets/video/orang_usual_var1_real.mp4';
import video_pink_fail_1_real from '@src/assets/video/pinkk_usual_var1_real.mp4';
import video_purple_fail_1_real from '@src/assets/video/purpl_usual_var1_real.mp4';
import video_yellow_fail_1_real from '@src/assets/video/yello_usual_var1_real.mp4';

export const SOCKET_URL = import.meta.env.VITE_API_URL + '/ws/';
export const SERVER_API_URL = `${import.meta.env.VITE_API_URL}/v1/gameflow`;
export const ASSETS = [
    {
        name: 'video_poster',
        url: video_poster,
        type: 'video/mp4'
    },
    //3D video
    {
        name: 'video_black_win_1',
        url: video_black_win_1,
        type: 'video/mp4'
    },
    {
        name: 'video_black_win_2',
        url: video_black_win_2,
        type: 'video/mp4'
    },
    {
        name: 'video_blue_win_1',
        url: video_blue_win_1,
        type: 'video/mp4'
    },
    {
        name: 'video_green_win_1',
        url: video_green_win_1,
        type: 'video/mp4'
    },
    {
        name: 'video_light_blue_win_1',
        url: video_light_blue_win_1,
        type: 'video/mp4'
    },
    {
        name: 'video_orange_win_1',
        url: video_orange_win_1,
        type: 'video/mp4'
    },
    {
        name: 'video_pink_win_1',
        url: video_pink_win_1,
        type: 'video/mp4'
    },
    {
        name: 'video_purple_win_1',
        url: video_purple_win_1,
        type: 'video/mp4'
    },
    {
        name: 'video_yellow_win_1',
        url: video_yellow_win_1,
        type: 'video/mp4'
    },

    // REAL videos
    {
        name: 'video_black_win_1_real',
        url: video_black_win_1_real,
        type: 'video/mp4'
    },
    {
        name: 'video_black_win_2_real',
        url: video_black_win_2_real,
        type: 'video/mp4'
    },
    {
        name: 'video_blue_win_1_real',
        url: video_blue_win_1_real,
        type: 'video/mp4'
    },
    {
        name: 'video_green_win_1_real',
        url: video_green_win_1_real,
        type: 'video/mp4'
    },
    {
        name: 'video_light_blue_win_1_real',
        url: video_light_blue_win_1_real,
        type: 'video/mp4'
    },
    {
        name: 'video_orange_win_1_real',
        url: video_orange_win_1_real,
        type: 'video/mp4'
    },
    {
        name: 'video_pink_win_1_real',
        url: video_pink_win_1_real,
        type: 'video/mp4'
    },
    {
        name: 'video_purple_win_1_real',
        url: video_purple_win_1_real,
        type: 'video/mp4'
    },
    {
        name: 'video_yellow_win_1_real',
        url: video_yellow_win_1_real,
        type: 'video/mp4'
    },

    // FAIL 3D Videos

    {
        name: 'video_black_fail_1',
        url: video_black_fail_1,
        type: 'video/mp4'
    },
    {
        name: 'video_black_fail_2',
        url: video_black_fail_2,
        type: 'video/mp4'
    },
    {
        name: 'video_blue_fail_1',
        url: video_blue_fail_1,
        type: 'video/mp4'
    },
    {
        name: 'video_green_fail_1',
        url: video_green_fail_1,
        type: 'video/mp4'
    },
    {
        name: 'video_light_blue_fail_1',
        url: video_light_blue_fail_1,
        type: 'video/mp4'
    },

    {
        name: 'video_orange_fail_1',
        url: video_orange_fail_1,
        type: 'video/mp4'
    },
    {
        name: 'video_pink_fail_1',
        url: video_pink_fail_1,
        type: 'video/mp4'
    },
    {
        name: 'video_purple_fail_1',
        url: video_purple_fail_1,
        type: 'video/mp4'
    },
    {
        name: 'video_yellow_fail_1',
        url: video_yellow_fail_1,
        type: 'video/mp4'
    },

    // FAIL REAL Videos

    {
        name: 'video_black_fail_1_real',
        url: video_black_fail_1_real,
        type: 'video/mp4'
    },
    {
        name: 'video_black_fail_2_real',
        url: video_black_fail_2_real,
        type: 'video/mp4'
    },
    {
        name: 'video_blue_fail_1_real',
        url: video_blue_fail_1_real,
        type: 'video/mp4'
    },
    {
        name: 'video_green_fail_1_real',
        url: video_green_fail_1_real,
        type: 'video/mp4'
    },
    {
        name: 'video_light_blue_fail_1_real',
        url: video_light_blue_fail_1_real,
        type: 'video/mp4'
    },

    {
        name: 'video_orange_fail_1_real',
        url: video_orange_fail_1_real,
        type: 'video/mp4'
    },
    {
        name: 'video_pink_fail_1_real',
        url: video_pink_fail_1_real,
        type: 'video/mp4'
    },
    {
        name: 'video_purple_fail_1_real',
        url: video_purple_fail_1_real,
        type: 'video/mp4'
    },
    {
        name: 'video_yellow_fail_1_real',
        url: video_yellow_fail_1_real,
        type: 'video/mp4'
    },
    // -----
    {
        name: 'audio_idle',
        url: audio_idle,
        type: 'audio/mp3'
    },
    {
        name: 'audio_gameplay',
        url: audio_gameplay,
        type: 'audio/mp3'
    },
    {
        name: 'audio_amb',
        url: audio_amb,
        type: 'audio/mp3'
    },
    {
        name: 'audio_amount_count_up',
        url: audio_amount_count_up,
        type: 'audio/mp3'
    },
    {
        name: 'audio_play_button',
        url: audio_play_button,
        type: 'audio/mp3'
    },
    {
        name: 'audio_basic_click',
        url: audio_basic_click,
        type: 'audio/mp3'
    },
    {
        name: 'audio_modal_open',
        url: audio_modal_open,
        type: 'audio/mp3'
    },
    {
        name: 'audio_transition',
        url: audio_transition,
        type: 'audio/mp3'
    },
    {
        name: 'audio_spin_ball_spin',
        url: audio_spin_ball_spin,
        type: 'audio/mp3'
    },
    {
        name: 'audio_spin_ball_mults',
        url: audio_spin_ball_mults,
        type: 'audio/mp3'
    },
    {
        name: 'audio_wof_double_win',
        url: audio_wof_double_win,
        type: 'audio/mp3'
    },
    {
        name: 'audio_win_reaction',
        url: audio_win_reaction,
        type: 'audio/mp3'
    },
    {
        name: 'audio_chip',
        url: audio_chip,
        type: 'audio/mp3'
    },
    {
        name: 'audio_default_win',
        url: audio_default_win,
        type: 'audio/mp3'
    },
    {
        name: 'audio_big_win',
        url: audio_big_win,
        type: 'audio/mp3'
    },
    {
        name: 'audio_super_win',
        url: audio_super_win,
        type: 'audio/mp3'
    },
    {
        name: 'audio_epic_win',
        url: audio_epic_win,
        type: 'audio/mp3'
    },
    {
        name: 'audio_mega_win',
        url: audio_mega_win,
        type: 'audio/mp3'
    },
    {
        name: 'audio_plinko_start_position',
        url: audio_plinko_start_position,
        type: 'audio/mp3'
    },
    {
        name: 'audio_plinko_multipliers_appearance',
        url: audio_plinko_multipliers_appearance,
        type: 'audio/mp3'
    },
    {
        name: 'audio_plinko_collide',
        url: audio_plinko_collide,
        type: 'audio/mp3'
    },
    {
        name: 'audio_plinko_mult_win',
        url: audio_plinko_mult_win,
        type: 'audio/mp3'
    },
    {
        name: 'audio_plinko_double',
        url: audio_plinko_double,
        type: 'audio/mp3'
    },
    {
        name: 'audio_wof_appears',
        url: audio_wof_appears,
        type: 'audio/mp3'
    },
    {
        name: 'audio_wof_start',
        url: audio_wof_start,
        type: 'audio/mp3'
    },
    {
        name: 'audio_wof_spin',
        url: audio_wof_spin,
        type: 'audio/mp3'
    },
    {
        name: 'audio_wof_stop',
        url: audio_wof_stop,
        type: 'audio/mp3'
    },
    {
        name: 'audio_wof_win',
        url: audio_wof_win,
        type: 'audio/mp3'
    },
    {
        name: 'audio_bonus_reels_spin',
        url: audio_bonus_reels_spin,
        type: 'audio/mp3'
    },
    {
        name: 'audio_bonus_reels_left_stop',
        url: audio_bonus_reels_left_stop,
        type: 'audio/mp3'
    },
    {
        name: 'audio_bonus_reels_right_stop',
        url: audio_bonus_reels_right_stop,
        type: 'audio/mp3'
    },
    {
        name: 'audio_cash_reels_spin',
        url: audio_cash_reels_spin,
        type: 'audio/mp3'
    },
    {
        name: 'audio_cash_reels_stop',
        url: audio_cash_reels_stop,
        type: 'audio/mp3'
    },
    {
        name: 'audio_cash_reels_mult_win',
        url: audio_cash_reels_mult_win,
        type: 'audio/mp3'
    },
    {
        name: 'audio_cash_reels_choice',
        url: audio_cash_reels_choice,
        type: 'audio/mp3'
    }
];

export const GAME_EVENTS = {
    HANDSHAKE: 'HANDSHAKE',
    GAME_INIT: 'GAME_INIT',
    GAME_PARAMS: 'GAME_PARAMS',
    PREV_GAMES: 'PREV_GAMES',
    SPLASH: 'SPLASH',
    VIDEO: 'VIDEO',
    BALANCE: 'BALANCE',
    STARTED: 'GAME_STARTED',
    BETS_ACCEPTED: 'BETS_ACCEPTED',
    POSSIBLE_PROFIT: 'POSSIBLE_PROFIT',
    COUNTER: 'COUNTER',
    CLAW_PROGRESS: 'CLAW_PROGRESS',
    TEXT: 'TEXT',
    BET: 'BET',
    BET_MULTIPLIERS: 'BET_MULTIPLIER',
    WHEEL_RESULT: 'WHEEL_RESULT',
    RESULTS: 'GAME_RESULT',
    // events call
    // manual SKIP
    FAST_RESULT: 'FAST_RESULT'
};

export const STREAM_STATUSES = {
    UNKNOWN: 'UNKNOWN',
    START_BUFFERING: 'START_BUFFERING',
    IS_PLAYING: 'IS_PLAYING'
};

export const POSSIBLE_AUTO_BET_TIMES = [10, 20, 30, 40, 50, 100, 200];

export const SKIP_WELCOME_SCREEN_STORAGE_KEY = '___skip_welcome_screens';
export const SKIP_FULL_SCREEN_TOOLBAR_IOS_STORAGE_KEY = '___skip_full_screen_toolbar_ios';
export const USER_SETTINGS__STORAGE_KEY = '__user_settings';

export const MODAL_TABS = {
    INFO: 'INFO',
    SETTINGS: 'SETTINGS'
};

export const NOTIFICATION_TYPES = {
    WARNING: 'WARNING',
    INFO: 'INFO',
    SUCCESS: 'SUCCESS',
    DANGER: 'DANGER'
};

export const COMMON_BUTTON_VARIANTS = {
    PRIMARY: 'primary',
    SECONDARY: 'secondary'
};

export const BONUS_GAMES = {
    PLINKO: 'PLINKO',
    FORTUNE_WHEEL: 'FORTUNE_WHEEL',
    CASH_REELS: 'CASH_REELS',
    BALL_SPIN: 'BALL_SPIN'
};

export const IS_DEV = import.meta.env.VITE_IS_DEVELOPMENT === 'true';

let isLocal = false;

const isLocalDev = import.meta.env.VITE_IS_LOCAL_DEV;
if (isLocalDev !== undefined) isLocal = isLocalDev === 'true';

export const IS_LOCAL = isLocal;

export const GAME_COLORS = {
    BLACK: 'BLACK',
    LIGHT_BLUE: 'LIGHT_BLUE',
    PURPLE: 'PURPLE',
    ORANGE: 'ORANGE',
    PINK: 'PINK',
    BLUE: 'BLUE',
    YELLOW: 'YELLOW',
    GREEN: 'GREEN'
};
